import * as z from 'zod';
export const GroupSchema = z.object({
    id: z.uuidv7(),
    name: z.string().min(1),
    createdAt: z.int().nonnegative(),
});
export const VariationSchema = z.object({
    id: z.uuidv7(),
    value: z.string().min(1),
    displayValue: z.string().min(1),
    groupId: z.uuidv7(),
    createdAt: z.int().nonnegative(),
});
export const CreateGroupSchema = z.object({
    name: z.string().min(1),
    variations: z.array(z.object({
        value: z.string().min(1),
        displayValue: z.string().min(1),
    })),
});
const VariationOperationSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('new'),
        value: z.string().min(1),
        displayValue: z.string().min(1),
    }),
    z.object({
        type: z.literal('remove'),
        variationId: z.uuidv7(),
    }),
]);
export const MergeGroupSchema = z.object({
    groupIds: z.array(z.uuidv7()).min(2),
    name: z.string().min(1),
    additionalNames: z.array(z.string().min(1)).optional(),
});
export const UpdateGroupSchema = z.object({
    name: z.string().min(1).optional(),
    variationOperations: z.array(VariationOperationSchema).optional(),
});
export const GroupCountsQuerySchema = z.object({
    participantId: z.uuidv7().optional(),
});
export const GroupCountSchema = z.object({
    id: z.uuidv7(),
    count: z.int(),
});
export const GroupVariationCountSchema = z.object({
    normalizedName: z.string(),
    count: z.int(),
});
export const NameCountSchema = z.object({
    normalizedName: z.string(),
    count: z.int(),
});
export const GetUngroupedBodySchema = z.object({
    participantId: z.uuidv7().optional(),
    pageNum: z.number().int().positive(),
    pageSize: z.number().int().positive().max(50),
});
const SearchUngroupedBaseSchema = z.object({
    participantId: z.uuidv7().optional(),
    pageNum: z.number().int().positive(),
    pageSize: z.number().int().positive().max(50),
});
export const SearchUngroupedBodySchema = z.discriminatedUnion('type', [
    SearchUngroupedBaseSchema.extend({
        type: z.literal('fuzzy'),
        q: z.string().min(1).max(100),
        threshold: z.number().min(0).max(1).multipleOf(0.01),
    }),
    SearchUngroupedBaseSchema.extend({
        type: z.literal('startsWith'),
        q: z.string().min(1).max(100),
    }),
    SearchUngroupedBaseSchema.extend({
        type: z.literal('includes'),
        q: z.string().min(1).max(100),
    }),
]);
export const NameFrequencySchema = z.object({
    normalizedName: z.string(),
    nameSample: z.string(),
    count: z.int(),
});
//# sourceMappingURL=group.js.map